<template>
  <div class="top-menu">
    <ul class="top-menu-link-list">
      <li 
        :class="'top-menu-link-item top-' + menu.url.function_code" 
        v-for="menu in menus" 
        :key="menu.url.path"
      >
        <MenuLink
          :url="menu.url.path"
          :external="menu.url.external"
          class="top-menu-link-inner"
        >
          <p class="top-menu-link-icon">
            <i :class="['fa-fw', menu.icon]"></i>
          </p>
          <p class="top-menu-link-name" v-html="menu.name" />
        </MenuLink>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      required: true
    }
  }
}
</script>
